module.exports = __webpack_public_path__ + "10738324d8ff90fb56eac018d60df62d.png";